/*eslint-disable */
import _ from 'lodash'

export function getQuoteNbrs (state) {
  let result = _.forEach(state.quoteNbrs, (nbrs, cid) => {
    _.orderBy(nbrs, (n) => {
      return Number(n.id)
    }, ['asc'])
  })
  return result
}

export function getQuoteNbrsX (state) {
  let result = _.forEach(state.quoteNbrsX, (nbrs, cid) => {
    _.orderBy(nbrs, (n) => {
      return Number(n.id)
    }, ['asc'])
  })
  return result
}

export function getSearchFilterObj (state) {
  return state.searchFilterObj
}

export function isPinnedImages (state) {
  return state.isPinnedImages
}

export function getIsPlayNotificationSound (state) {
  return state.isPlayNotificationSound
}

export function getIsNeedRefreshTable (state) {
  return state.isNeedRefreshTable
}

export function getToken (state) {
  return state.token
}

export function getTokens (state) {
  return state.tokens
}

export function getAllRfqs (state) {
  return state.fullSorted
}

export function getSearchIndexById(state) {
  return state.searchIndexById
}

export function getCurrentRFQViewing (state) {
  return _.find(state.items, (itm) => {
    return Number(itm.id) === Number(state.currentRfq.id)
  })?.viewingUsers
}

export function getNewRFQs (state) {
  return state.newSorted
}

export function getPricedRFQs (state) {
  return state.pricedSorted
}

export function getWonRFQs (state) {
  return state.wonSorted
}

export function getOrderedRFQs (state) {
  return state.orderedSorted
}

export function getLostRFQs (state) {
  return state.lostSorted
}

export function getClosedRFQs (state) {
  return state.closedSorted
}

export function getCurrentRFQ (state) {
  return state.currentRfq
}

export function getFilter (state) {
  return state.filter
}

export function countNewRFQs (state, getters) {
  return getters.getNewRFQs.length
}

export function countPricedRFQs (state, getters) {
  return getters.getPricedRFQs.length
}

export function countWonRFQs (state, getters) {
  return getters.getWonRFQs.length
}

export function countOrderedRFQs (state, getters) {
  return getters.getOrderedRFQs.length
}

export function countLostRFQs (state, getters) {
  return getters.getLostRFQs.length
}

export function getAllRFQsCurrentPage (state) {
  return state.allRFQsCurrentPage
}

export function getNewRFQsCurrentPage (state) {
  return state.newRFQsCurrentPage
}

export function getPricedRFQsCurrentPage (state) {
  return state.pricedRFQsCurrentPage
}

export function getWonRFQsCurrentPage (state) {
  return state.wonRFQsCurrentPage
}

export function getOrderedRFQsCurrentPage (state) {
  return state.orderedRFQsCurrentPage
}

export function getClosedRFQsCurrentPage (state) {
  return state.closedRFQsCurrentPage
}

export function getLostRFQsCurrentPage (state) {
  return state.lostRFQsCurrentPage
}

export function getPerPage (state) {
  return state.perPage
}
